import UserProfileContext from '../../context/userprofilecontext.js';

import React, { Fragment, useContext } from 'react';

export default function CurrentOrgRequired(props) {
    const userProfileContext = useContext(UserProfileContext);
    const userProfile = userProfileContext.userProfile;

    if (!userProfile.currentOrg || !userProfile.currentOrg.orgID) {
        return <Fragment>You are not currently working in an organization.</Fragment>;
    }

    return <Fragment>{props.children}</Fragment>;
}